/**
 * Extras / add-ons checkbox list.
 * Uses group-scoped `extras` from the parent (Extras filtered by
 * `vehicle.allowed_extra_ids` via the /vehicles/{id}/extras endpoint).
 */
export default function AddonPicker({ extras, selected, onToggle }) {
  return (
    <div className="mt-6" data-testid="addon-picker">
      <p className="overline mb-3">Add-ons</p>
      {extras.length === 0 ? (
        <p className="text-xs text-neutral-500 italic">
          No extras available for this vehicle.
        </p>
      ) : (
        <div className="space-y-2">
          {extras.map((a) => (
            <label
              key={a.id}
              className="flex items-center justify-between cursor-pointer py-2 border-b border-black/5"
            >
              <span className="flex items-center gap-3 text-sm">
                <input
                  type="checkbox"
                  checked={selected.includes(a.id)}
                  onChange={() => onToggle(a.id)}
                  className="w-4 h-4 accent-black"
                  data-testid={`addon-${a.id}`}
                />
                {a.name}
              </span>
              <span className="text-sm text-neutral-500">
                €{Number(a.price).toFixed(a.price % 1 === 0 ? 0 : 2)}/
                {a.pricing_type === "per_day" ? "day" : "res"}
              </span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
